import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { Box, Divider } = designSystem;

const BlockSettingsOptionDivider = ({ marginTop = 'spacing-m', marginBottom = 'spacing-s' }) => (
  <Box marginTop={marginTop} marginBottom={marginBottom}>
    <Divider appearance="light-grey" />
  </Box>
);

BlockSettingsOptionDivider.propTypes = {
  marginTop: PropTypes.string,
  marginBottom: PropTypes.string,
};

export default BlockSettingsOptionDivider;
